import { svgIconFactory } from './icon-factory';

function Swap() {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M17.6782 0.0315276L17.0203 0.124906C16.6171 0.218284 16.214 0.358351 15.832 0.521762C14.323 1.24747 13.2085 2.70666 12.8187 4.46698C12.6065 5.37742 12.6065 6.33454 12.8187 7.22163C12.0124 7.22163 11.206 7.10491 10.4421 6.87147C8.05964 6.28649 5.83505 5.09517 3.94695 3.39314C3.3662 2.89211 2.83883 2.32043 2.37489 1.68899C2.19588 1.49487 2.03258 1.28398 1.88682 1.05869V1.05869C1.63854 1.53594 1.44603 2.04577 1.31388 2.57608L1.31388 2.57608C0.912446 4.46456 1.35388 6.45042 2.50221 7.92198C2.77807 8.29549 3.20248 8.52894 3.47834 8.85576H3.47834C3.23642 8.90233 2.98763 8.87818 2.75685 8.78573H2.75685C2.37124 8.71566 1.99399 8.5982 1.63219 8.43556L1.05924 8.20212V8.20212C0.99352 10.26 1.95363 12.1934 3.56322 13.2445C4.0725 13.6647 4.66667 13.9215 5.30327 14.0149C4.96375 14.3417 3.45712 14.2017 2.92661 14.1316C3.45712 15.9058 4.70911 17.2831 6.30239 17.8901C6.81167 18.1002 7.34218 18.1936 7.87268 18.1936C7.43196 18.6 6.9473 18.945 6.42971 19.2207C5.43226 19.8196 4.35958 20.2522 3.24668 20.5047C2.75862 20.6214 2.24933 20.5981 1.69761 20.6914H1.69761C1.13114 20.7381 0.561701 20.7146 0 20.6214L0.466844 20.9249C0.954909 21.2517 1.44297 21.5318 1.97347 21.7653C2.99204 22.2322 4.03183 22.6057 5.09284 22.8858C7.59682 23.4694 10.2086 23.3761 12.6702 22.6057C18.2316 20.6914 21.7542 16.2093 23.0928 9.60278C23.305 8.36552 23.3899 7.08158 23.3475 5.82097L24.1963 5.0506C24.9017 4.3955 25.5102 3.62369 26 2.76284V2.76284C25.042 3.22854 24.0266 3.53535 22.9867 3.67328C23.1989 3.55656 23.3899 3.39315 23.5809 3.20639C24.3873 2.48271 24.9814 1.52559 25.2997 0.45174L24.6419 0.848596C23.7806 1.35253 22.8478 1.69196 21.8833 1.85241C20.8033 0.59141 19.2738 -0.0830742 17.7012 0.00819745V0.031542H17.6782L17.6782 0.0315276Z"
        fill="url(#paint0_linear_531_9295)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_531_9295"
          x1="25.5357"
          y1="23.2632"
          x2="2.87592"
          y2="-2.52686"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0050" />
          <stop offset="0.714448" stopColor="#7000FF" />
          <stop offset="1" stopColor="#0027FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const TwitterIcon = svgIconFactory(Swap);
